import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { GoldBadge } from '@/components/Luxury';

interface CollapsibleSectionProps {
  title: string;
  subtitle?: string;
  defaultOpen?: boolean;
  badge?: string;
  deltaBadge?: string;  // Phase 173: e.g., "2 modified"
  children: React.ReactNode;
}

export function CollapsibleSection({
  title,
  subtitle,
  defaultOpen = true,
  badge,
  deltaBadge,
  children,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-charcoal border border-slate-dark rounded-xl overflow-hidden">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-6 cursor-pointer text-left"
      >
        <div className="flex items-center gap-3">
          <h3 className="font-serif text-gold text-lg">{title}</h3>
          {badge && <GoldBadge>{badge}</GoldBadge>}
          {deltaBadge && (
            <span className="text-sm bg-amber-100 text-amber-700 border border-amber-300 px-1.5 py-0.5 rounded-full font-medium">
              {deltaBadge}
            </span>
          )}
        </div>
        <div className="flex items-center gap-3">
          {subtitle && (
            <span className="text-stone-400 text-sm">{subtitle}</span>
          )}
          <ChevronDown
            className={`w-5 h-5 text-stone-400 transition-transform duration-300 ease-in-out ${
              isOpen ? 'rotate-180' : ''
            }`}
          />
        </div>
      </button>
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          <div className="px-6 pb-6">{children}</div>
        </div>
      </div>
    </div>
  );
}
